module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a6-5-f97574f3401adafed1540bbd7449b5eb.jpg";